// Contract Management Permissions

export const CONTRACTS_INDEX = 40;
// Show follows index: anyone who can list contracts can open one.
export const CONTRACTS_SHOW = CONTRACTS_INDEX;
export const CONTRACTS_CREATE = 41;
export const CONTRACTS_EDIT = 42;
export const CONTRACTS_DELETE = 43;
export const CONTRACTS_RESTORE = 1393;
export const CONTRACTS_TERMINATE = 292;

/* Contract Renewal and Approval UPDATE permissions */
export const CONTRACTS_RENEW = 294;
export const CONTRACTS_APPROVE = 294;

// Contract Conditions Templates
export const CONTRACTS_CONDITIONS_TEMPLATES_CREATE = 44;
export const CONTRACTS_CONDITIONS_TEMPLATES_LIST = 45;
export const CONTRACTS_CONDITIONS_TEMPLATES_DELETE = 46;
export const CONTRACTS_CONDITIONS_TEMPLATES_UPDATE = 47;
export const CONTRACTS_CONDITIONS_TEMPLATES_SHOW =
  CONTRACTS_CONDITIONS_TEMPLATES_LIST;
export const CONTRACTS_CONDITIONS_TEMPLATES_RESTORE = 1388;

// Other Contract Permissions
export const CONTRACTS_ASSIGN_SERVICE = 114;
export const CONTRACTS_EJAR_SUBMIT = 315; // contracts.ejar.submit
export const CONTRACTS_PUBLISH = 294;

export const CONTRACTS_PRINT = 1292;
// Producing the document is one capability: download is gated by the print permission.
export const CONTRACTS_DOWNLOAD = CONTRACTS_PRINT;
// No dedicated attachments endpoint: the tab reads the contract itself.
export const CONTRACTS_ATTACHMENTS_INDEX = CONTRACTS_SHOW;

/** ejar.contracts.download-pdf — Download authenticated Ejar contract PDF */
export const CONTRACTS_EJAR_DOWNLOAD_PDF = 1373;

export const UNITS_UNLINK_EJAR_AUTH = 1340;
